import { render } from "./Submission.vue?vue&type=template&id=77d099d8"
import script from "./Submission.vue?vue&type=script&lang=js"
export * from "./Submission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__